import { apiService, handleResponse } from '@/services/apiService';
import type { OrderInterface } from '../orders/type';

export class StripeTerminalRepository {

    async createPaymentIntent(amount: number, currency: string = 'eur', order: OrderInterface, construction_site: string, email?: string) {
        const response = await apiService.post(`/v1/stripe/payment-intent`, {
            amount: amount,
            currency,
            order: order,
            construction_site,
            email
        });
        return handleResponse(response);
    }

    async processPayment(paymentIntentId: string) {
        const response = await apiService.post(`/v1/stripe/process-payment`, {
            payment_intent_id: paymentIntentId,
        });
        return handleResponse(response);
    }

    async simulatePayment(paymentIntentId: string) {
        const response = await apiService.post(`/v1/stripe/simulate-payment`, {
            payment_intent_id: paymentIntentId,
        });
        return handleResponse(response);
    }

    async getPaymentStatus(paymentIntentId: string) {
        const response = await apiService.get(`/v1/stripe/payment-status/${paymentIntentId}`);
        return handleResponse(response);
    }

    async capturePayment(paymentIntentId: string) {
        const response = await apiService.post(`/v1/stripe/capture-payment`, {
            payment_intent_id: paymentIntentId,
        });
        return handleResponse(response);
    }

    async simulateTap() {
        const response = await apiService.post(`/v1/stripe/simulate-tap`, {});
        return handleResponse(response);
    }

    async cancelPayment(paymentIntentId: string, cancellation_comment?: string) {
        const response = await apiService.post(`/v1/stripe/cancel-payment`, {
            payment_intent_id: paymentIntentId,
            cancellation_comment: cancellation_comment,
        });
        return handleResponse(response);
    }

    async cancelTerminal() {
        const response = await apiService.post(`/v1/stripe/cancel-terminal`, {});
        return handleResponse(response);
    }
}
